export enum OfferTypeEnum {
    RENTAL = 'RENT',
    SALES = 'SALES',
}